import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { useShopAuth } from '../../context/ShopAuthContext';

export default function ShopRegister() {
  const { register } = useShopAuth();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success('Account created! Welcome to Bison Shop.');
      navigate('/shop');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Registration failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <h1 className="text-3xl font-serif font-bold mb-2">Create your account</h1>
      <p className="text-sm text-muted-foreground mb-6">Track orders, save addresses, and check out faster.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="shop-register-form">
        <div><Label>Full name</Label><Input required value={form.name} onChange={(e) => setForm(f => ({...f, name: e.target.value}))} data-testid="register-name" /></div>
        <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e) => setForm(f => ({...f, email: e.target.value}))} data-testid="register-email" /></div>
        <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm(f => ({...f, phone: e.target.value}))} placeholder="+250 7xx xxx xxx" data-testid="register-phone" /></div>
        <div><Label>Password</Label><Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm(f => ({...f, password: e.target.value}))} data-testid="register-password" /></div>
        <Button type="submit" className="w-full" disabled={busy} data-testid="register-submit">{busy ? 'Creating account…' : 'Create account'}</Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">Already a member? <Link to="/shop/login" className="text-primary hover:underline" data-testid="register-to-login">Sign in</Link></p>
    </div>
  );
}
